import React from "react";
import "../lifehacks/ArticleFull.css";

const DriverLicenseBrazil = () => {
  return (
    <div className="article-full">
      <h1 className="article-title">
        🚗 Как заменить российские водительские права на бразильские (CNH) во Флорианополисе
      </h1>

      <p className="article-text">
        Бразилия признаёт водительские удостоверения из России — вы можете заменить их на местные бразильские права (CNH) без сдачи экзаменов. 
        Ниже — подробная пошаговая инструкция, как это сделать во Флорианополисе, штат Санта-Катарина.
      </p>

      <h3 className="article-section-title">✅ Условия</h3>
      <ul className="article-list">
        <li>Возраст от 18 лет</li>
        <li>Российские права действительны (не просрочены)</li>
        <li>Есть ВНЖ в Бразилии (CRNM или протокол на рассмотрении)</li>
        <li>Оформлен CPF</li>
        <li>Есть подтверждение адреса</li>
        <li>Проживание в Бразилии более 180 дней</li>
      </ul>

      <h3 className="article-section-title">📝 Необходимые документы</h3>
      <ul className="article-list">
        <li>Российские права (оригинал)</li>
        <li>Присяжный перевод прав (tradução juramentada)</li>
        <li>CRNM (или протокол)</li>
        <li>CPF</li>
        <li>Подтверждение адреса (договор аренды, счёт за электричество и т.д.)</li>
        <li>Фото 3×4 (часто не требуется — делают на месте)</li>
      </ul>

      <h3 className="article-section-title">📍 Где делается</h3>
      <p className="article-text">
        DETRAN-SC, Флорианополис<br />
        Адрес: Avenida Governador Ivo Silveira, 1521 - Capoeiras<br />
        Сайт: <a href="https://www.detran.sc.gov.br" target="_blank" rel="noopener noreferrer">https://www.detran.sc.gov.br</a><br />
        Онлайн-запись: <a href="https://servicos.detran.sc.gov.br/agendamento" target="_blank" rel="noopener noreferrer">https://servicos.detran.sc.gov.br/agendamento</a><br />
        Выбирайте опцию <strong>Habilitação → Averbação de Habilitação Estrangeira</strong>
      </p>

      <h3 className="article-section-title">🔄 Полный порядок действий</h3>
      <ul className="article-list">
        <li>
          <strong>1. Сделать присяжный перевод российских прав</strong><br />
          Перевод делается у аккредитованного переводчика (tradução juramentada).<br />
        </li>
        <li>
          <strong>2. Записаться в DETRAN онлайн</strong><br />
          Зайти на: <a href="https://servicos.detran.sc.gov.br/agendamento" target="_blank" rel="noopener noreferrer">https://servicos.detran.sc.gov.br/agendamento</a><br />
          → выбрать <strong>Habilitação → Averbação de Habilitação Estrangeira</strong><br />
          Выберите дату и время приёма.
        </li>
        <li>
          <strong>3. Прийти в DETRAN с документами</strong><br />
          С собой: Перевод российских прав, Оригинальные российские права, CRNM или протокол, CPF, Подтверждение адреса (договор аренды)
        </li>
        <li>
          <strong>4. Получить направление к врачу и психологу</strong><br />
          На месте в DETRAN вам дадут:<br />
          Направление к окулисту (exame médico)<br />
          И к психологу (exame psicológico)<br />
          <span className="article-note-text">⚠️ <strong>Важно:</strong> сначала нужно пройти психолога, затем окулиста.</span><br />
          🟡 Врачи — аккредитованные DETRAN специалисты.<br />
          📱 Запись обычно осуществляется по WhatsApp (контакты дадут в DETRAN).
        </li>
        <li>
          <strong>5. Получение цифровых прав</strong><br />
          После прохождения обоих специалистов:<br />
          Данные передаются в DETRAN<br />
          На следующий день права появляются в цифровом виде (PDF) на e-mail<br />
          <span className="article-note-text">⚠️ <strong>Если не пришли</strong> — один из врачей не отправил заключение</span>
        </li>
        <li>
          <strong>6. Получение бумажной версии прав</strong><br />
          Через 5–7 рабочих дней можно прийти в DETRAN и получить бумажную CNH.
        </li>
      </ul>

      <h3 className="article-section-title">💰 Стоимость</h3>
      <ul className="article-list">
        <li>Психолог — ~R$75</li>
        <li>Окулист — ~R$75</li>
        <li>Водительские права (CNH) — ~R$105</li>
      </ul>

      <h3 className="article-section-title">🕑 Весь процесс занимает</h3>
      <ul className="article-list">
        <li>Перевод прав: 1–3 дня</li>
        <li>Онлайн-запись и визит в DETRAN: 1 день</li>
        <li>Прохождение врачей: 1–2 дня</li>
        <li>Получение цифровых прав: на следующий день</li>
        <li>Бумажные права: через 7 дней</li>
      </ul>

      <div className="article-note">
        <p className="article-note-text">
          💡 <strong>Полезные советы:</strong><br />
          Сделайте копии всех документов<br />
          Проверьте, чтобы российские права были без повреждений и действительны<br />
          Лучше записываться к врачам сразу после визита в DETRAN, чтобы не терять время<br />
          Если нужна помощь с записью — сотрудники DETRAN часто помогают на месте
        </p>
      </div>
    </div>
  );
};

export default DriverLicenseBrazil;